"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingLeaderboardRank = void 0;
var StakingLeaderboardRank;
(function (StakingLeaderboardRank) {
    StakingLeaderboardRank["GOLD"] = "GOLD";
    StakingLeaderboardRank["SILVER"] = "SILVER";
    StakingLeaderboardRank["BRONZE"] = "BRONZE";
    StakingLeaderboardRank["BASIC"] = "BASIC";
})(StakingLeaderboardRank || (exports.StakingLeaderboardRank = StakingLeaderboardRank = {}));
//# sourceMappingURL=leaderboard.js.map